export default __webpack_public_path__ + "advantage-50ca1d6.png";